import { createUseStyles } from 'react-jss';
import { ThemeProps } from '@styles/theme';
import { textOverflowDots } from '@resources/mixins';

export const useStyles = createUseStyles((theme: ThemeProps) => ({
    mainWrapper: {
        width: '20%',
        height: '100%',
        backgroundColor: theme.colors.grey_background,
        boxShadow: '4px 0 12px 0 rgba(115, 115, 115, 0.12)',
    },
    headerWraper: {
        width: '100%',
        height: '90px',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
        display: 'flex',
        alignItems: 'center',
        padding: 15,

        '& img':{
            marginRight: theme.spacing(2),
            width: 30,
            height: 30,

            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    userAvatar: {
        display: 'inline-flex',
        marginRight: theme.spacing(3),
        [theme.down('desktop')]: {
            display: 'none',
        },
    },
    fullNameContaier: {
        ...textOverflowDots(),
        fontSize: 18,
        fontWeight: '700',
        fontFamily: theme.font.secondary,
    },
    headerLabel:{
        display: 'flex',
        alignItems: 'center',

        '& img': {
            marginRight: theme.spacing(2),
            height: 24,
            width: 24,
        },
    },
    groupsWrapper: {
        width: '100%',
        maxHeight: '100px',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
    },
    groupsHeader: {
        height: '24px',
        margin: `20px 20px 16px 20px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    groupsContainer:{
        minHeight: '24px',
        margin: '16px 20px 20px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-evenly',
    },
    groupContainer: {
        borderRadius: theme.radius,
        backgroundColor: theme.colors.transp_violet,
        marginRight: 5,
        padding: theme.spacing(1),
    },
    proceduresWrapper: {
        width: '100%',
        maxHeight: 'calc(50% - 90px)',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
    },
    proceduresHeader: {
        height: '30px',
        margin: `10px 20px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },
    competenciesWrapper: {
        width: '100%',
        maxHeight: 'calc(50% - 90px)',
        borderBottom: `2px solid ${theme.colors.grey_light}`,
    },
    competenciesHeader: {
        height: '30px',
        margin: `10px 20px`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',

        '& img': {
            '&:hover':{
                backgroundColor: theme.colors.transp_blue,
            },
        },
    },

    tableContainer: {
        height: '100%',
        minHeight: 0,
        overflow: 'hidden',
    },

    highlightedRow: {
        backgroundColor: `${theme.colors.transp_blue_darker} !important`,
    },

    clickableRow: {
        cursor: 'pointer',
        transition: 'background-color 140ms ease',

        '&:hover': {
            backgroundColor: `${theme.colors.transp_violet} !important`,
        },
    },

    dataContainer: {
        background: theme.colors.transp_violet,
        borderRadius: '4px',
        padding: '0 8px',
        minHeight: '30px',
        alignContent: 'center',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: 1.2,
    },

}));